import { render, staticRenderFns } from "./VerClientesTreinos.vue?vue&type=template&id=0abc9dba&"
import script from "./VerClientesTreinos.vue?vue&type=script&lang=js&"
export * from "./VerClientesTreinos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports